import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalRootFn = /* @__PURE__ */ createRecipe('modal-root', {}, [])

const modalRootVariantMap = {}

const modalRootVariantKeys = Object.keys(modalRootVariantMap)

export const modalRoot = /* @__PURE__ */ Object.assign(memo(modalRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'modalRoot',
  __getCompoundVariantCss__: modalRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: modalRootVariantKeys,
  variantMap: modalRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalRootVariantKeys)
  },
  getVariantProps: modalRootFn.getVariantProps,
})